import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {ListaSolicitante} from "../../cadastro/models/lista-solicitante";
import {ListaUsuario} from "../models/lista-usuario";
import {NovoUsuario} from "../models/novo-usuario";
import {UsuarioDetalhes} from "../models/usuario-detalhes";
import {NovaSenha} from "../models/nova-senha";
import {UsuarioInformacoes} from "../../../core/models/usuario-informacoes";
import {environment} from "@env/environment";

@Injectable({
  providedIn: 'root'
})
export class UsuarioService{
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`UsuarioService`);
  }

  baseUrl = environment.apiUrl;

  selecionarLista(): Observable<BaseResponse<ListaUsuario> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaUsuario>>(`${this.baseUrl}/Usuario`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  selecionarListaAtivos(): Observable<BaseResponse<ListaSolicitante> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaSolicitante>>(`${this.baseUrl}/pessoa/ativos`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  adicionar(request: NovoUsuario): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Usuario`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  alterar(request: UsuarioDetalhes):  Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Usuario`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('alterar')));
  }

  alterarSenha(request: NovaSenha):  Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Usuario/AlterarSenha`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('alterar')));
  }
  esqueciSenha(email: string): Observable<BaseResponse<boolean>> {
    return this.http.post<BaseResponse<boolean>>(`${this.baseUrl}/Usuario/EsqueciSenha?email=${encodeURIComponent(email)}`, {});
  }
  resetarSenha(id: number): Observable<BaseResponse<boolean>> {
    return this.http.post<BaseResponse<boolean>>(`${this.baseUrl}/Usuario/${id}/ResetarSenha`, {});
  }

  buscarPorId(id: number): Observable<BaseResponse<UsuarioDetalhes> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<UsuarioDetalhes>>(`${this.baseUrl}/Usuario/` + id)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorId')));
  }

  desativar(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<boolean>>(`${this.baseUrl}/Usuario/Desativar/` + id)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('desativar')));
  }

  ativar(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<boolean>>(`${this.baseUrl}/Usuario/Ativar/` + id)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('ativar')));
  }

  desbloquear(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<boolean>>(`${this.baseUrl}/Usuario/Desbloquear/` + id)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('desbloquear')));
  }

  confirmarEmail(token: string): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<boolean>>(`${this.baseUrl}/Usuario/ConfirmarEmail/` + token)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('confirmarEmail')));
  }

  buscarInformacoes(): Observable<BaseResponse<UsuarioInformacoes> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<UsuarioInformacoes>>(`${this.baseUrl}/Usuario/Informacoes/`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarInformacoes')));
  }

  habilitarTutorial(): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Usuario/HabilitarTutorial`, null)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('habilitarTutorial')));
  }

  encerrarTutorial(): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Usuario/EncerrarTutorial`, null)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('encerrarTutorial')));
  }

  buscarPorEmail(email: string): Observable<BaseResponse<UsuarioDetalhes> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<UsuarioInformacoes>>(`${this.baseUrl}/Usuario/BuscarPorEmail/` + email)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorEmail')));
  }
}
